module.exports = __webpack_public_path__ + "static/logo-varsity-4f04cc4b445bb59625c0de7f1c807fbc.png";